import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import {
  SET_TICKER_INFO,
  SOCKET_SUBSCRIBE,
  SOCKET_UNSUBSCRIBE,
  NOTI_TIMEOUT,
  BASE_URL
} from './types';

export function onBuySell({ type, account, amount, fileContent, activePortfolioId }) {
  const url = `${BASE_URL()}/api/buysell`;
  const request = axios.post(url, { type, account, amount, fileContent, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  })
  return (dispatch) => {
    request.then(data => {
      const blob = new Blob([data.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'INDIVIDUALTRADES.csv';
      link.click();
    }).catch(() => {
      NotificationManager.error(`There was an error generating the buy/sell file. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function onAddRemove({ type, symbol, sector, activePortfolioId }) {
  const url = `${BASE_URL()}/api/addremove`;
  const request = axios.post(url, { type, symbol, sector, activePortfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  })
  return (dispatch) => { 
    request.then(data => {
      dispatch({ type: SET_TICKER_INFO, payload: data });
      if (type === 'add') {
        dispatch({ type: SOCKET_SUBSCRIBE, payload: [symbol] });                
      } else {
        dispatch({ type: SOCKET_UNSUBSCRIBE, payload: [symbol] });                          
      }
    }).catch(() => {
      NotificationManager.error(`There was an error ${type === 'add' ? 'adding' : 'removing'} the ticker: ${symbol}. Please try again.`, 'Error!', NOTI_TIMEOUT);                          
    });
  }
}

export function onPreviewQuarterly({ date, activePortfolioId }) {
  const url = `${BASE_URL()}/api/previewquarterly`;
  return (dispatch) => {
    return axios.post(url, { date, activePortfolioId }, {
      headers: { authorization: localStorage.getItem('token') }
    }).catch(() => {
      NotificationManager.error(`There was an error fetching quarterly preview. Please try again.`, 'Error!', NOTI_TIMEOUT);
      throw new Error('Preview fetch failed');
    });
  };
}

export function onQuarterly({ date, activePortfolioId, previewData }) {
  const url = `${BASE_URL()}/api/updatequarterly`;
  const body = previewData ? { date, activePortfolioId, previewData } : { date, activePortfolioId };
  const request = axios.post(url, body, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => { 
    request.then(data => {
      dispatch({ type: SET_TICKER_INFO, payload: data });  
    }).catch(() => {
      NotificationManager.error(`There was an error updating quarterly data. Please try again.`, 'Error!', NOTI_TIMEOUT);                    
    });
  }
}

export function generatePrintout({ htmlBody, type }) {
  const url = `${BASE_URL()}/api/generateprintout`;
  const request = axios.post(url, { htmlBody, type }, {
    headers: { authorization: localStorage.getItem('token') },
    responseType: 'arraybuffer'
  });
  return (dispatch) => { 
    request.then(data => {
      const blob = new Blob([data.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      if (type === 'dashboard') {
        link.download = 'Dashboard Printout.pdf';
      } else {
        link.download = 'Client Printout.pdf';
      }
      link.click();
    }).catch(() => {
      NotificationManager.error(`There was an error generating the printout. Please try again.`, 'Error!', NOTI_TIMEOUT);            
    });
  }
}

export function consolidateFiles({ files, percentQty, price, ticker }) {
  const url = `${BASE_URL()}/api/consolidatefiles`;
  const request = axios.post(url, { files, percentQty, price, ticker }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then(data => {
      const blob = new Blob([data.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Block ${ticker}.csv`;
      link.click();
    }).catch((err) => {
      NotificationManager.error(`There was an error consolidating the files. Please try again.`, 'Error!', NOTI_TIMEOUT);            
    })
  }
}